/* eslint-disable */
import React, { useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
// chakra imports
import {
  Box,
  Flex,
  HStack,
  Text,
  Collapse,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { ChevronDownIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { useContext } from 'react';
import { SidebarContext } from 'contexts/SidebarContext';

export function SidebarLinks(props) {
  const { collapse } = props;

  const isChildRouteActive = (items = []) => {
    return items.some((item) => {
      const fullPath = `${item.layout || ''}${item.path || ''}`
        .replace('/*', '')
        .toLowerCase();

      return location.pathname.toLowerCase().startsWith(fullPath);
    });
  };

  const location = useLocation();
  const navigate = useNavigate(); // Add hook
  const [openIndex, setOpenIndex] = useState(null);
  const { toggleCollapse } = useContext(SidebarContext); // Use toggleCollapse instead of setCollapse

  // const activeBg = useColorModeValue('teal.50', 'whiteAlpha.200'); // OLD
  const activeBg = useColorModeValue(
    'linear-gradient(90deg, #38B2AC 0%, #319795 100%)', // Teal Gradient
    'linear-gradient(90deg, #38B2AC 0%, #319795 100%)',
  );
  const activeIcon = useColorModeValue('white', 'white'); // Icon white on active pill
  const activeColor = useColorModeValue('white', 'white'); // Text white on active pill
  const activeShadow = useColorModeValue(
    '0px 4px 12px 0px rgba(56, 178, 172, 0.3)', // Teal shadow
    '0px 4px 12px 0px rgba(56, 178, 172, 0.3)',
  );
  // const activeIcon = useColorModeValue('teal.500', 'teal.200'); // OLD
  // const activeColor = useColorModeValue('teal.700', 'white'); // OLD
  const inactiveColor = useColorModeValue('gray.500', 'gray.400');
  const textColor = useColorModeValue('secondaryGray.500', 'white');
  const hoverBg = useColorModeValue('gray.100', 'whiteAlpha.100');

  // New colors for active child links (darker/teal text on transparent bg)
  const activeChildIcon = useColorModeValue('teal.500', 'teal.200');
  const activeChildColor = useColorModeValue('teal.700', 'white');

  const { routes } = props;
  const activeRoute = (route) => {
    const fullPath = `${route.layout || ''}${route.path || ''}`
      .replace('/*', '') // remove wildcard
      .toLowerCase();

    return location.pathname.toLowerCase().startsWith(fullPath);
  };

  const toggleSubmenu = (index) => {
    if (collapse) {
      toggleCollapse(); // Open sidebar if closed (toggles false -> true)
      
      // Navigate to the first child item if available
      const clickedRoute = routes[index];
      if (clickedRoute && clickedRoute.items && clickedRoute.items.length > 0) {
        const firstChild = clickedRoute.items[0];
        const linkPath = (firstChild.layout || '') + (firstChild.path || '');
        navigate(linkPath);
      }

      setTimeout(() => {
        setOpenIndex(index);
      }, 100);
    } else {
      setOpenIndex(openIndex === index ? null : index);
    }
  };

  const createLinks = (routes, isChild = false) => {
    return routes.map((route, index) => {
      if (route.category) {
        if (collapse) return null; // Hide categories when collapsed
        return (
          <Box key={index}>
            <Text
              fontSize="sm"
              color={inactiveColor}
              fontWeight="bold"
              mx="auto"
              ps={{ sm: '10px', xl: '16px' }}
              pt="18px"
              pb="6px"
              textTransform="uppercase"
              letterSpacing="0.5px"
            >
              {route.name}
            </Text>
            {createLinks(route.items, true)}
          </Box>
        );
      }

      // Has submenu (children)
      if (route.collapse && route.items && route.items.length > 0) {
        const isOpen = openIndex === index;
        const isActive = isChildRouteActive(route.items);
        return (
          <Box key={index}>
            <Flex
              align="center"
              justify={collapse ? 'center' : 'space-between'}
              cursor="pointer"
              py={collapse ? '12px' : '10px'}
              px={collapse ? '0' : '12px'}
              mx={collapse ? 'auto' : '10px'}
              w={collapse ? '46px' : 'auto'}
              h={collapse ? '46px' : 'auto'}
              borderRadius={collapse ? '14px' : '12px'}
              bg={isActive ? activeBg : 'transparent'}
              _hover={{ bg: isActive ? activeBg : hoverBg }}
              transition="all 0.2s"
              mb="6px"
              onClick={() => toggleSubmenu(index)}
            >
              <HStack
                spacing={collapse ? '0' : '12px'}
                justify={collapse ? 'center' : 'flex-start'}
                align="center"
                w={collapse ? 'unset' : '100%'}
              >
                <Box
                  color={isActive ? activeIcon : textColor}
                  me={collapse ? '0px' : '12px'}
                  display="flex"
                  align="center"
                  justify="center"
                >
                  {route.icon}
                </Box>

                {!collapse && (
                  <Text
                    color={isActive ? activeColor : textColor}
                    fontWeight={isActive ? 'bold' : 'medium'}
                    fontSize="md"
                  >
                    {route.name}
                  </Text>
                )}
              </HStack>

              {!collapse && (
                <Icon
                  as={isOpen ? ChevronDownIcon : ChevronRightIcon}
                  color={isActive ? activeColor : textColor}
                  boxSize={4}
                />
              )}
            </Flex>

            <Collapse in={isOpen && !collapse} animateOpacity>
              <Box ps="10px" pe="10px">
                {createLinks(route.items, true)}
              </Box>
            </Collapse>
          </Box>
        );
      }

      if (route.layout === '/admin') {
        const isActive = activeRoute(route);
        return (
          <NavLink key={index} to={route.layout + route.path}>
            <Box
              py={collapse ? '12px' : '10px'}
              px={collapse ? '0' : '16px'}
              mx={collapse ? 'auto' : '10px'}
              w={collapse ? '46px' : 'auto'}
              h={collapse ? '46px' : 'auto'}
              borderRadius={collapse ? '14px' : isChild ? '0px' : '30px'}
              bg={
                isActive
                  ? isChild
                    ? 'transparent'
                    : activeBg
                  : 'transparent'
              }
              boxShadow={
                 isActive 
                  ? isChild 
                    ? 'none' 
                    : activeShadow 
                  : 'none'
              }
              borderBottom={
                isActive ? (isChild ? '2px solid' : 'none') : 'none'
              }
              borderColor={isActive ? (isChild ? activeIcon : 'transparent') : 'transparent'}
              _hover={{
                bg: isActive ? (isChild ? 'transparent' : activeBg) : hoverBg,
              }}
              transition="all 0.2s"
              mb="6px"
              display="flex"
              alignItems="center"
              justifyContent={collapse ? 'center' : 'flex-start'}
            >
              <Flex
                w="100%"
                alignItems="center"
                justifyContent={collapse ? 'center' : 'flex-start'}
              >
                <Box
                  color={
                    isActive
                      ? isChild
                        ? activeChildIcon
                        : activeIcon
                      : textColor
                  }
                  me={collapse ? '0px' : '12px'}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  {route.icon}
                </Box>
                {!collapse && (
                  <Text
                    me="auto"
                    color={
                      isActive
                        ? isChild
                          ? activeChildColor
                          : activeColor
                        : textColor
                    }
                    fontWeight={isActive ? 'bold' : 'medium'}
                    fontSize="md"
                  >
                    {route.name}
                  </Text>
                )}
              </Flex>
            </Box>
          </NavLink>
        );
      }

      return null;
    });
  };

  return <>{createLinks(routes)}</>;
}

export default SidebarLinks;
